/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable no-console */
/* eslint-disable camelcase */
import { loadCheckerFleetFinAndAtaDetails } from '../../models/checkerDetailsModel/checkerDetailsThunk';
import { useAppDispatch, useAppSelector } from '../../store/hooksTypes';
import { loadCheckerFinAndAtaOptions } from '../../utils/commonUtil';
import { CHECKER_RESULT, FIN, FIN_ACCESS_PANEL } from '../../utils/constants';

export function useCheckerColumns() {
  const checkerDetailsDispatcher = useAppDispatch();
  const {
    checkerTableClfState, fleet_detail_filter_selected, isColumnDataLoading, isFilterDetailsFinLoading,
  } = useAppSelector((state: any) => state.displayCheckerDetailsTable);
  const {
    fleet_fin, fin_status, edited, id_aircraft_registration, ata, fin_description, source, source_status, pnr, status_part_check, reason,
  } = checkerTableClfState;
  const featureToggleConfig = useAppSelector((state) => state.featureToggleDetails?.data);
  const featureToggleAccessPanel = featureToggleConfig?.access_panel === 'true';
  const isEditedFilterEnabled = featureToggleConfig?.checker_details_edited_filter === 'true';

  const loadFinOptions = () => {
    if (Object.entries(fleet_fin).length === 0) {
      loadCheckerFinAndAtaOptions(
        fleet_detail_filter_selected.operator_name,
        fleet_detail_filter_selected.aircraft_type,
        fleet_detail_filter_selected.selected_msn,
        checkerDetailsDispatcher,
        loadCheckerFleetFinAndAtaDetails,
      );
    }
  };

  const loadFinStatusOptions = () => {
    if (Object.entries(fin_status).length === 0) {
      console.log('Throw API call for fin_status');
    }
  };

  const loadEditedOptions = () => {
    if (Object.entries(edited).length === 0) {
      console.log('Throw API call for edited');
    }
  };

  const loadMsnOptions = () => {
    if (Object.entries(id_aircraft_registration).length === 0) {
      console.log('Throw API call for id_aircraft_registration');
    }
  };

  const loadAtaOptions = () => {
    if (Object.entries(ata).length === 0) {
      loadCheckerFinAndAtaOptions(
        fleet_detail_filter_selected.operator_name,
        fleet_detail_filter_selected.aircraft_type,
        fleet_detail_filter_selected.selected_msn,
        checkerDetailsDispatcher,
        loadCheckerFleetFinAndAtaDetails,
      );
    }
  };

  const loadFinDescriptionOptions = () => {
    if (Object.entries(fin_description).length === 0) {
      console.log('Throw API call for fin_description');
    }
  };

  const loadSourceOptions = () => {
    if (Object.entries(source).length === 0) {
      console.log('Throw API call for source');
    }
  };

  const loadSourceStatusOptions = () => {
    if (Object.entries(source_status).length === 0) {
      console.log('Throw API call for source_status');
    }
  };

  const loadPnrOptions = () => {
    if (Object.entries(pnr).length === 0) {
      console.log('Throw API call for pnr');
    }
  };

  const loadStatusOptions = () => {
    if (Object.entries(status_part_check).length === 0) {
      console.log('Throw API call for status_part_check');
    }
  };

  const loadReasonOptions = () => {
    if (Object.entries(reason).length === 0) {
      console.log('Throw API call for reason');
    }
  };

  const checkerFilterColumns = {
    groupProps: {
      isLoading: isColumnDataLoading,
    },
    columnProps: [
      {
        Header: featureToggleAccessPanel ? FIN_ACCESS_PANEL : FIN,
        filterType: 'ACB',
        id: 'fleet_fin',
        loadOptions: loadFinOptions,
        storeVariable: fleet_fin,
        filterName: 'fleet_fin',
        isLoading: isFilterDetailsFinLoading,
        isSortableColumn: true,
      },
      {
        Header: featureToggleAccessPanel ? CHECKER_RESULT : 'FIN Status',
        filterType: 'ACB',
        id: 'fin_status',
        loadOptions: loadFinStatusOptions,
        storeVariable: fin_status,
        filterName: 'fin_status',
        isLoading: isColumnDataLoading,
        isSortableColumn: true,
      },
      {
        Header: 'Edited',
        filterType: 'ACB',
        id: 'edited',
        loadOptions: loadEditedOptions,
        storeVariable: edited,
        filterName: 'edited',
        isLoading: isColumnDataLoading,
        isSortableColumn: false,
      },
      {
        Header: 'MSN',
        filterType: 'ACB',
        id: 'id_aircraft_registration',
        loadOptions: loadMsnOptions,
        storeVariable: id_aircraft_registration,
        filterName: 'id_aircraft_registration',
        isLoading: isColumnDataLoading,
        isSortableColumn: true,
      },
      {
        Header: 'ATA',
        filterType: 'ACB',
        id: 'ata',
        loadOptions: loadAtaOptions,
        storeVariable: ata,
        filterName: 'ata',
        isLoading: isFilterDetailsFinLoading,
        isSortableColumn: true,
      },
      {
        Header: 'Description',
        filterType: 'ACB',
        id: 'fin_description',
        loadOptions: loadFinDescriptionOptions,
        storeVariable: fin_description,
        filterName: 'fin_description',
        isLoading: isColumnDataLoading,
        isSortableColumn: true,
      },
      {
        Header: 'Source',
        filterType: 'ACB',
        id: 'data_source',
        loadOptions: loadSourceOptions,
        storeVariable: source,
        filterName: 'source',
        isLoading: isColumnDataLoading,
      },
      {
        Header: 'Source Status',
        filterType: 'ACB',
        id: 'status_part_check',
        loadOptions: loadSourceStatusOptions,
        storeVariable: status_part_check,
        filterName: 'status_part_check',
        isLoading: isColumnDataLoading,
      },
      {
        Header: 'Part Number',
        filterType: 'ACB',
        id: 'pnr',
        loadOptions: loadPnrOptions,
        storeVariable: pnr,
        filterName: 'pnr',
        isLoading: isColumnDataLoading,
      },
      {
        Header: 'Status',
        filterType: 'ACB',
        id: 'source_status',
        loadOptions: loadStatusOptions,
        storeVariable: source_status,
        filterName: 'source_status',
        isLoading: isColumnDataLoading,
      },
      {
        Header: 'Reason',
        filterType: 'ACB',
        id: 'reason',
        loadOptions: loadReasonOptions,
        storeVariable: reason,
        filterName: 'reason',
        isLoading: isColumnDataLoading,
      },
    ],
  };

  if (!isEditedFilterEnabled) {
    checkerFilterColumns.columnProps = checkerFilterColumns.columnProps.filter(
      (col) => col.id !== 'edited',
    );
  }
  return checkerFilterColumns;
}
